import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _isEmpty from 'lodash/isEmpty';
import { getSlidingCarouselElementStyle } from '../../services/carousel';
import { ARROW_POSITION } from '../../services/constants';
var top = ARROW_POSITION.top,
  bottom = ARROW_POSITION.bottom;
export function getArrowColumnWidth(isMobile, arrowsPositionMobile) {
  if (isMobile) {
    if (arrowsPositionMobile === top || arrowsPositionMobile === bottom) {
      return 8;
    }
  }
  return 1;
}
export function getItemsColumnWidth(isMobile, arrowsPositionMobile, displayLeftRightArrows) {
  if (!displayLeftRightArrows) {
    return 16;
  }
  if (isMobile) {
    if (arrowsPositionMobile === top || arrowsPositionMobile === bottom) {
      return 16;
    }
  }
  return 14;
}
export function renderSlideElements(_ref) {
  var items = _ref.items,
    activePage = _ref.activePage,
    pageSize = _ref.pageSize,
    renderItemContainer = _ref.renderItemContainer,
    stepSize = _ref.stepSize,
    totalPages = _ref.totalPages;
  return items.map(function (item, index) {
    var _getSlidingCarouselEl = getSlidingCarouselElementStyle({
        index: index,
        activePage: activePage,
        pageSize: pageSize,
        stepSize: stepSize,
        totalPages: totalPages
      }),
      elementClassName = _getSlidingCarouselEl.className,
      style = _getSlidingCarouselEl.style;
    return renderItemContainer(item, {
      className: elementClassName,
      style: style
    });
  });
}
export function getSlidingCarouselHeight(carouselRef) {
  var current = carouselRef.current;
  if (!current) {
    return 0;
  }
  var activeElements = current.querySelectorAll('.sliding-element.active.current');
  if (_isEmpty(activeElements)) {
    return 0;
  }
  var activeElementsHeights = _toConsumableArray(activeElements).map(function (element) {
    return element.offsetHeight;
  });
  return Math.max.apply(Math, _toConsumableArray(activeElementsHeights));
}